import { useQuery } from 'react-query';

import { MyClientProvider } from 'api/clients/types';
import { getInfoPestCompany } from 'api/clients/getInfoPestCompany';

export interface IPestCompany {
  name: string;
  logo: string;
}
export const useGetPestCompany = (options?: any) => {
  const { data, refetch, isLoading, isRefetching } = useQuery(
    ['pest-company'], // Use page and search as query keys to refetch on changes
    () => getInfoPestCompany(),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,

      select: (response: MyClientProvider | null) => (response ? response : null),
      ...options,
    },
  );

  return { data, refetch, isLoading, isRefetching };
};

export default useGetPestCompany;
